import { jsx as o } from "react/jsx-runtime";
import { Icon as n } from "@chakra-ui/react";
import { FontAwesomeIcon as r } from "@fortawesome/react-fontawesome";
import { faMinus as c } from "@fortawesome/pro-solid-svg-icons/faMinus";
import { faCheck as s } from "@fortawesome/pro-solid-svg-icons/faCheck";
const l = ({ isIndeterminate: m, isChecked: t }) => t ? m ? /* @__PURE__ */ o(n, { as: r, icon: c }) : /* @__PURE__ */ o(n, { as: r, icon: s }) : null;
export {
  l as default
};
